import PropTypes from 'prop-types';

export const ChildrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);

/**
 * @typedef {(JSX.Element|JSX.Element[])} ChildrenPropType
 */
